import axios from 'axios';
import onCartUpdate from './onCartUpdate';

async function replaceCartContent() {
  const cartPage = await axios.get('/cart');
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(cartPage.data, 'text/html');

  // Update cart page
  const destinationCartEl = document.getElementById('cart');
  const sourceCartEl = htmlDoc.getElementById('cart');
  if (destinationCartEl && sourceCartEl) destinationCartEl.innerHTML = sourceCartEl.innerHTML;

  // Update cart drawer
  const destinationCartDrawerEl = document.querySelector('#cart-drawer .drawer-content-wrapper');
  const sourceCartDrawerEl = htmlDoc.querySelector('#cart-drawer .drawer-content-wrapper');
  if (destinationCartDrawerEl && sourceCartDrawerEl) destinationCartDrawerEl.innerHTML = sourceCartDrawerEl.innerHTML;

  // Update cart count in header
  const destinationCartCountEl = document.querySelector('.text-cart_count');
  const sourceCartCountEl = htmlDoc.querySelector('.text-cart_count');
  if (destinationCartCountEl && sourceCartCountEl) destinationCartCountEl.replaceWith(sourceCartCountEl);

  // update cart dot in header
  const destinationCartDotEl = document.querySelector('.text-cart_dot');
  const sourceCartDotEl = htmlDoc.querySelector('.text-cart_dot');
  if (destinationCartDotEl && sourceCartDotEl) destinationCartDotEl.replaceWith(sourceCartDotEl);

  const destinationClubMembershipToggle = destinationCartDrawerEl?.querySelector('#club-membership-toggle');
  if (destinationClubMembershipToggle) {
    if (sessionStorage.getItem('wants_become_club_member') == 'true') {
      destinationClubMembershipToggle.setAttribute("checked", "checked");
    } else {
      destinationClubMembershipToggle.removeAttribute("checked");
      document.querySelectorAll('.single-item-cart').forEach((item) => {
        const price = item.getAttribute('data-price-formatted');
        item.querySelector('bdi').textContent = price;
      });
    }

  }

  onCartUpdate();
}

export default replaceCartContent;
